import React from 'react';
import COLORS from '../utils/colors';

export const InlineCode = ({ ...props }) => {
  return (
    <code
      style={{
        fontSize: '1em',
        padding: '0 0.2em',
        backgroundColor: COLORS.offwhite,
        color: COLORS.darkblue,
        borderRadius: '3px',
        textAlign: 'left',
        fontFamily: "'Roboto Mono', monospace",
      }}
      {...props}
    />
  );
};
